import { createGlobalStyle } from 'styled-components';
import { colors, fonts } from './theme';

const GlobalStyles = createGlobalStyle`
    * {
    border: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    font-weight: inherit;
    margin: 0;
    outline: 0;
    padding: 0;
    text-decoration: none;
    text-rendering: optimizeLegibility;
    -webkit-appearance: none;
    -moz-appearance: none;
    position:relative;
  }


  html {
    display: flex;
    min-height: 100%;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 1.5;
    padding: 0;
    margin: 0;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    font-weight: 400;
    background: ${colors.limestone};
  }

  body {
    background: ${colors.limestone};
    color: ${colors.ink};
    font-family: ${fonts.body};
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overscroll-behavior-y: none;
    -webkit-overflow-scrolling: touch;
    font-weight: 400;
    -ms-overflow-style: none;  scrollbar-width: none;
    ::-webkit-scrollbar { width: 0 !important }
  }

  /* No italics anywhere: slanted type is harder for dyslexic and many neurodivergent
     readers. Emphasis uses colour and weight instead. */
  em, i, cite, dfn, address, var {
    font-style: normal;
  }

  ::selection {
    background: ${colors.clay};
    color: ${colors.ink};
  }

  a {
    color: currentColor;
    text-decoration: none;
  }

  a:hover {
    cursor: pointer;
  }

  a:focus-visible,
  button:focus-visible {
    outline: 2px solid ${colors.copper};
    outline-offset: 4px;
    border-radius: 4px;
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyles;
